import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  STOP_COPYING_BUTTON: `${cleanedFilename(__filename)}-stop-copying-button`,
  PRIMARY_ACTION_BUTTON: `${cleanedFilename(__filename)}-primary-action-button`,
};
